import { GetBusinessSeatsType as ApiBusinessSeatsType } from 'src/api/generated/touring/types';
import { mapMoneyType } from '../../../common';
import { BusinessSeatsType } from '../../types';

export const mapBusinessSeatsType = (
  apiType: ApiBusinessSeatsType
): BusinessSeatsType => {
  return {
    maxSeats: apiType.maxSeats,
    uplift: apiType.uplift ? mapMoneyType(apiType.uplift) : null,
    share: apiType.share ? mapMoneyType(apiType.share) : null,
    notes: apiType.notes,
  };
};
